<template>
  <div id="AccountInvoices" class="Main-Content">

    <LoadingLayout v-if="loading" :page="true" />

    <Page
      v-else
      :title="$t('Invoices')"
    >

      <template>
        <Layout>
          <LayoutSection>
            <Card>
              <DataTable
                :columns="[
                  {
                    key: 'invoiceNumber',
                    label: $t('AccountInvoices.Invoice #')
                  },
                  {
                    key: 'forDate',
                    label: $t('For Month'),
                    format: 'dateMonthYearLong',
                    sortable: true
                  },
                  {
                    key: 'amount',
                    label: $t('Total'),
                    format: 'currency',
                    sortable: true,
                    formatContext: context
                  }
                ]"
                :row-actions="(n) => getRowActions(n)"
                :sort.sync="sortBy"
                :rows="formattedInvoices"
                :pagination="{
                  offset: offset,
                  limit: limit,
                  total: formattedInvoices.length,
                  updateOffset: val => offset = val,
                  updateLimit: updateLimit
                }"
                :loading="loading"
                compact
              />
            </Card>
          </LayoutSection>
        </Layout>
      </template>

    </Page>

  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AccountInvoices',
  data () {
    return {
      loading: true,
      exporting: false,
      invoices: [],
      offset: 0,
      sortBy: {
        column: 'forDate',
        direction: 'desc'
      },
      limit: 10
    }
  },
  mounted() {
    NProgress.start()
    this.limit = this.getTableLimit('tableLimit') || 10
    this.api.getInvoices()
      .then((data) => {
        this.invoices = data
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  computed: {
    formattedInvoices() {
      let invoices = this.invoices.map(i => {
        const formattedDate = window.moment({ year: i.forYear, month: i.forMonth - 1}).format('YYYY-MM-DD')
        return {
          ...i,
          forDate: formattedDate
        }
      })
      
      if (this.sortBy) {
        invoices = _.orderBy(invoices, [this.sortBy.column], [this.sortBy.direction])
      }
      return invoices
    },
  },
  methods: {
    context(row) {
      return {
        currency: row.currency
      }
    },
    downloadInvoice(row) {
      NProgress.start()
      this.exporting = true
      this.api.getInvoiceDowloadUrl(row.invoiceNumber)
      .then((url) => {
        window.open(url)
      })
      .catch(this.apiCatch)
      .finally(() => {
        this.exporting = false
        NProgress.done()
      })
    },
    viewTransaction(row) {
      const stDate = window.moment(row.forDate).startOf('month').format('YYYY-MM-DD')
      const endDate = window.moment(row.forDate).endOf('month').format('YYYY-MM-DD')
      this.$router.push({ name: 'AccountTransactions', query: { startDate: stDate, endDate: endDate }})
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
    },
    getRowActions(row) {
      let actions = [
        {
          label: this.$t('AccountInvoices.View Transactions'),
          onAction: () => this.viewTransaction(row)
        }
      ]
      if (row.fileName) {
        actions.push({
          label: this.$t('Download'),
          disabled: this.exporting,
          onAction: () => this.downloadInvoice(row)
        })
      }
      return actions
    }
  }
}

</script>
